import { 
  getUsers,
  setEmailFilter, 
  setCountryFilter 
} from 'reduxpath/ducks/User/List'

import Home from 'units/User'
import List from 'units/User/units/List'

import {
  getCountries,
  setSelectionsCountry,
  setSelectedCountry,
} from 'reduxpath/ducks/Reference'

const list = (store) => {
  const { selectedCountry } = store.getState().Reference

  if (selectedCountry) {
    store.dispatch(setSelectedCountry(selectedCountry))
  }

  store.dispatch(setEmailFilter(''))
  store.dispatch(setCountryFilter(''))

  store.dispatch(
    getUsers({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
      where: {
        or: [
          { hasAgreedTnc: true },
          { source: { '!': 'admin' } },
        ],
        source: { '!': 'getcraft' },
      },
    }),
  )

  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
    }),
  )
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
    List,
  },
}
